/*
  elestablo 2026 · Formularios web → Kommo (mejora progresiva).
  Intercepta el envío de <form data-ee-kommo="servicio"> y manda los datos al webhook de n8n, que crea el lead en Kommo.
  - Si n8n responde { ok: true }: muestra el mensaje de éxito del formulario ([data-ee-kommo-ok]) sin recargar.
  - Si falla la red, tarda más de 12 s o responde otra cosa: deja que el formulario nativo de Shopify se envíe (correo).
  - Si faltan datos que Kommo exige (celular colombiano de 10 dígitos o la autorización Ley 1581): envío nativo.
  Campos que lee (atributo data-ee-campo): nombre, celular, municipio, mensaje, correo, autoriza, hp (honeypot).
  URL del webhook: atributo data-ee-kommo-url del formulario o la de abajo.
  Escucha en fase de captura (window) para adelantarse al captcha de Shopify (script "captcha-bootstrap", que
  escucha en document y detiene el envío de los formularios de contacto). Si el lead entra a Kommo, el captcha
  no se usa; en el respaldo nativo se llama requestSubmit() y el captcha de Shopify hace su trabajo normal.
*/
(function () {
  'use strict';
  if (window.eeFormKommo) return;
  window.eeFormKommo = true;

  var URL_WEBHOOK = 'https://n8n-n8n.3rhc7s.easypanel.host/webhook/web-formulario';
  var ESPERA_MS = 12000;

  function campo(form, nombre) {
    return form.querySelector('[data-ee-campo="' + nombre + '"]');
  }
  function valor(form, nombre) {
    var el = campo(form, nombre);
    return el ? String(el.value || '').trim() : '';
  }
  function celularValido(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('57') === 0) d = d.slice(2);
    return /^3\d{9}$/.test(d);
  }
  function boton(form, ocupado) {
    var b = form.querySelector('[type="submit"]');
    if (!b) return;
    b.disabled = ocupado;
    if (ocupado) b.setAttribute('aria-busy', 'true');
    else b.removeAttribute('aria-busy');
  }
  function envioNativo(form) {
    form.setAttribute('data-ee-kommo-estado', 'nativo');
    boton(form, false);
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else HTMLFormElement.prototype.submit.call(form);
  }
  function mostrarExito(form, servicio) {
    form.removeAttribute('data-ee-kommo-estado');
    boton(form, false);
    form.reset();
    var viejos = form.querySelectorAll('[data-ee-kommo-previo]');
    for (var i = 0; i < viejos.length; i++) viejos[i].hidden = true;
    var ok = form.querySelector('[data-ee-kommo-ok]');
    if (ok) {
      ok.hidden = false;
      ok.setAttribute('tabindex', '-1');
      try { ok.focus({ preventScroll: true }); } catch (e) { ok.focus(); }
      if (ok.scrollIntoView) ok.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form_servicio: servicio, lead_destino: 'kommo' });
    } catch (e) { /* sin analítica no pasa nada */ }
  }

  window.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[data-ee-kommo]')) return;
    if (ev.defaultPrevented) return;
    var estado = form.getAttribute('data-ee-kommo-estado');
    if (estado === 'nativo') return;
    if (estado === 'enviando') { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
    if (!window.fetch || !window.JSON) return;

    var autoriza = campo(form, 'autoriza');
    var mensaje = valor(form, 'mensaje');
    var correo = valor(form, 'correo');
    if (correo) mensaje = (mensaje ? mensaje + '\n\n' : '') + 'Correo: ' + correo;
    var servicio = form.getAttribute('data-ee-kommo') || 'contacto';
    var datos = {
      nombre: valor(form, 'nombre').slice(0, 80),
      celular: valor(form, 'celular'),
      municipio: valor(form, 'municipio').slice(0, 80),
      mensaje: mensaje.slice(0, 2000),
      servicio: servicio.slice(0, 80),
      pagina: String(window.location.href).slice(0, 500),
      autoriza_datos: !!(autoriza && autoriza.checked),
      hp: valor(form, 'hp')
    };
    // Kommo exige celular válido y autorización: si no están, sigue el envío nativo (llega por correo).
    if (datos.nombre.length < 2 || !celularValido(datos.celular) || !datos.autoriza_datos) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();
    form.setAttribute('data-ee-kommo-estado', 'enviando');
    boton(form, true);

    var control = window.AbortController ? new AbortController() : null;
    var reloj = setTimeout(function () { if (control) control.abort(); }, ESPERA_MS);
    fetch(form.getAttribute('data-ee-kommo-url') || URL_WEBHOOK, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
      signal: control ? control.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        clearTimeout(reloj);
        if (j && j.ok === true) mostrarExito(form, servicio);
        else envioNativo(form);
      })
      .catch(function () {
        clearTimeout(reloj);
        envioNativo(form);
      });
  }, true);
})();
